import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import BottomNav from '@/components/layout/BottomNav';
import Header from '@/components/layout/Header';
import AuthModal from '@/components/layout/AuthModal';
import AddressModal from '@/components/layout/AddressModal';
import LocationBanner from '@/components/layout/LocationBanner';
import PWAInstallBanner from '@/components/PWAInstallBanner';
import HomePage from '@/pages/HomePage';
import MenuPage from '@/pages/MenuPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import CartPage from '@/pages/CartPage';
import CheckoutPage from '@/pages/CheckoutPage';
import OrderTrackingPage from '@/pages/OrderTrackingPage';
import MyOrdersPage from '@/pages/MyOrdersPage';
import ProfilePage from '@/pages/ProfilePage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import AdminLayout from '@/pages/admin/AdminLayout';
import OrdersPage from '@/pages/admin/OrdersPage';
import OrderDetailPage from '@/pages/admin/OrderDetailPage';
import BranchesPage from '@/pages/admin/BranchesPage';
import ZonesPage from '@/pages/admin/ZonesPage';
import CategoriesPage from '@/pages/admin/CategoriesPage';
import ProductsPage from '@/pages/admin/ProductsPage';
import ReportsPage from '@/pages/admin/ReportsPage';
import HomeConfigPage from '@/pages/admin/HomeConfigPage';
import PromotionsPage from '@/pages/admin/PromotionsPage';
import CouponsPage from '@/pages/admin/CouponsPage';
import PushCampaignsPage from '@/pages/admin/PushCampaignsPage';
import UsersPage from '@/pages/admin/UsersPage';

function AppContent() {
  const [showAuth, setShowAuth] = useState(false);
  const [showAddress, setShowAddress] = useState(false);

  const openLocation = () => setShowAddress(true);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Header onAddressClick={openLocation} />
      <LocationBanner onSetLocation={openLocation} />
      <PWAInstallBanner />
      <main className="max-w-7xl mx-auto">
        <Routes>
          <Route path="/" element={<HomePage onAddressClick={openLocation} />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/producto/:id" element={<ProductDetailPage />} />
          <Route path="/carrito" element={<CartPage onAuthRequired={() => setShowAuth(true)} onSetLocation={openLocation} />} />
          <Route path="/checkout" element={<CheckoutPage onSetLocation={openLocation} />} />
          <Route path="/pedido/:id" element={<OrderTrackingPage />} />
          <Route path="/mis-pedidos" element={<MyOrdersPage onAuthRequired={() => setShowAuth(true)} />} />
          <Route path="/perfil" element={<ProfilePage onAuthRequired={() => setShowAuth(true)} />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </main>
      <BottomNav />
      <AuthModal open={showAuth} onClose={() => setShowAuth(false)} />
      <AddressModal open={showAddress} onClose={() => setShowAddress(false)} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Admin Panel - separate layout without store header/nav */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<OrdersPage />} />
              <Route path="pedidos" element={<OrdersPage />} />
              <Route path="pedidos/:id" element={<OrderDetailPage />} />
              <Route path="sucursales" element={<BranchesPage />} />
              <Route path="zonas" element={<ZonesPage />} />
              <Route path="categorias" element={<CategoriesPage />} />
              <Route path="productos" element={<ProductsPage />} />
              <Route path="configuracion-home" element={<HomeConfigPage />} />
              <Route path="promociones" element={<PromotionsPage />} />
              <Route path="cupones" element={<CouponsPage />} />
              <Route path="promos-push" element={<PushCampaignsPage />} />
              <Route path="usuarios" element={<UsersPage />} />
              <Route path="reportes" element={<ReportsPage />} />
            </Route>
            {/* Customer-facing store */}
            <Route path="*" element={<AppContent />} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
